import Logo from 'components/Logo';

const LogoSection = () => <Logo isHorizontal size={150} />;

export default LogoSection;
